"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../i18n");
var _Dropdown = _interopRequireDefault(require("./Dropdown"));
var _Label;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Label = (0, _i18n.withTranslation)('app.product')(function (props) {
  return /*#__PURE__*/_react.default.createElement("span", props);
});
var FilterBox = function FilterBox(_ref) {
  var options = _ref.options,
    selected = _ref.selected,
    children = _ref.children,
    select = _ref.select;
  return /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    options: [{
      value: null,
      enabled: true
    }].concat(options),
    selected: selected,
    select: select,
    header: function header(selection) {
      return selection ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children, /*#__PURE__*/_react.default.createElement("span", null, " (", selection && selection.trim(), ")")) : children;
    }
  }, function (value) {
    return value || _Label || (_Label = /*#__PURE__*/_react.default.createElement(Label, {
      intlKey: "show_all"
    }, "Show all"));
  });
};
var _default = exports.default = FilterBox;